export const MESSAGE_EXPIRATION_NONE = 0
export const expirationOptions = [
  {
    value: MESSAGE_EXPIRATION_NONE,
    title: 'createNotification.dialog.messageExpiration.none',
  },
  {
    value: 60 * 60,
    title: 'createNotification.dialog.messageExpiration.1h',
  },
  {
    value: 60 * 60 * 12,
    title: 'createNotification.dialog.messageExpiration.12h',
  },
  {
    value: 60 * 60 * 24,
    title: 'createNotification.dialog.messageExpiration.1d',
  },
  {
    value: 60 * 60 * 24 * 7,
    title: 'createNotification.dialog.messageExpiration.1w',
  },
  {
    value: 60 * 60 * 24 * 30,
    title: 'createNotification.dialog.messageExpiration.1m',
  },
  {
    value: 60 * 60 * 24 * 365,
    title: 'createNotification.dialog.messageExpiration.1y',
  },
]
